import { render, staticRenderFns } from "./CourseBasicItem.vue?vue&type=template&id=2019b834&scoped=true"
import script from "./CourseBasicItem.vue?vue&type=script&lang=js"
export * from "./CourseBasicItem.vue?vue&type=script&lang=js"
import style0 from "./CourseBasicItem.vue?vue&type=style&index=0&id=2019b834&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2019b834",
  null
  
)

export default component.exports